import { isLightColor } from '@/functions/isLightColor';
import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import transitions from 'vuetify/lib/components/transitions';
import { i18n } from './vue-i18n';
import { cdi } from './coredataIcons';
import getScrollbarWidth from '@/functions/getScrollBarWidth';

Vue.use(Vuetify, {
  components: { ...transitions.$_vuetify_subcomponents }, // register all transitions globally for non-vuetify components
});

const scrollBarWidth = getScrollbarWidth();

// https://stackoverflow.com/a/68293406/11532124
document.documentElement.style.setProperty(
  '--scrollbar-width',
  scrollBarWidth + 'px'
);

const opts = {
  theme: {
    themes: {
      light: {
        get branding() {
          return this.primary;
        },
        get onBranding() {
          return isLightColor(this.branding) ? '#000' : '#FFF';
        },
        get anchor() {
          return this.secondary;
        },
        primary: '#E95C23',
        secondary: '#4198B4',
        background: '#fff',
        chipBackground: '#E7E7EE',
        chipClose: '#414D55',
        chipText: '#4384A0',
        chipAvatarErrorText: '#B33933',
        formLabel: '#000',
        hover: '#ECECEC',
        success: '#2AAC9B',
        successAccent: '#1CC257',
        warning: '#F2A60D',
        warningAccent: '#FA7A33',
        error: '#ED474A',
        delete: '#E74545',
        edit: '607D8B',
        errorAccent: '#F33C30',
        info: '#62A6C4',
        infoAccent: '#62A6C4',
        disabled: '#DBDBDB',
        disabledBorder: '#C4C4C4',
        bgGrayOutside: '#F2F4F4',
        bgGrayPlanning: '#FAFAFA',
        planningAvailability: '#fbd892',
        positive: '#29E251',
        heading: '#0A2540',
        tableHeader: '#414D55',
        text: '#1D1E24',
        subtitleText: '#5C5C5C',
        titleText: '#1C1C1C',
        tableLine: '#F4F4F7',
        tableAlternateLine: '#F0F0F0', //color assigned when we have multiple rows in table and in each other line we assign color so users dont confuse lines
        tableHover: '#D9D9E3',
        tableGroupedRow: '#F8F8F8',
        addButtonText: '#000',
        addButtonHover: '#EAF7F5',
        addButtonActive: '#BFE6E1',
        editButton: '#607D8B',
        avatarBorder: '#CACACA',
        avatarBackground: '#FFF',
        avatarTitleForIndex: '#007BFF',
        avatarBorderOverlap: '#FFF',
        titleForBaseSection: '#007BFF',
      },
      dark: {
        get branding() {
          return this.primary;
        },
        get onBranding() {
          return isLightColor(this.branding) ? '#000' : '#FFF';
        },
        get anchor() {
          return this.secondary;
        },
        primary: '#E1353F',
        secondary: '#4384A0',
        background: '#272727',
        chipBackground: '#888888',
        chipClose: '#A0A0A0',
        chipText: '#001f3f',
        formLabel: '#fff',
        hover: '#000',
        success: '#2AAC9B',
        successAccent: '#1CC257',
        warning: '#FF7557',
        warningAccent: '#FA7A33',
        error: '#EA6265',
        errorAccent: '#F33C30',
        info: '#62A6C4',
        infoAccent: '#62A6C4',
        disabled: '#B5B5B5',
        bgGrayOutside: '#272727',
        bgGrayPlanning: '#272727',
        planningAvailability: '#fbd892',
        tableLine: '#444',
        tableAlternateLine: '#363636',
        positive: '#29E251',
        heading: '#FFFFFF',
        tableHeader: '#FFFFFF',
        tableHover: '#000',
        text: '#FFFFFF',
        tableGroupedRow: '#616161',
        addButtonText: '#FFF',
        addButtonHover: '#515a63',
        addButtonActive: '#293d46',
        editButton: '#607D8B',
        avatarBorder: '#CACACA',
        avatarBackground: '#D0D0D0',
        avatarTitleForIndex: '#FFF',
        avatarBorderOverlap: '#FFF',
        titleForBaseSection: '#007BFF',
      },
    },
    options: {
      customProperties: true,
      variations: false,
    },
  },
  breakpoint: {
    // max-width breakpoints
    thresholds: {
      xs: 500,
      sm: 900,
      md: 1200,
      lg: 1650,
    },
    scrollBarWidth: scrollBarWidth,
  },
  lang: {
    t: (msg, ...params) => i18n.t(msg, params), // see src/i18n/[lang].js for including vuetify translations for new languages
    current: 'nl', // main.js watcher
  },
  icons: {
    values: cdi,
  },
};

export default new Vuetify(opts);
